/**
 * URL-safe slug derivation. Mirrors the API's slug regex
 * (`^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$`) so anything we auto-generate
 * passes the server-side schema without re-typing.
 *
 *  - lowercase
 *  - decompose accents and strip combining marks (so "Tinubu's Address" → "tinubus-address",
 *    "Yorùbá" → "yoruba", "Café" → "cafe")
 *  - everything not [a-z0-9] becomes a separator
 *  - collapse runs of separators to a single hyphen
 *  - trim leading/trailing hyphens
 *  - cap at 80 chars (well under the API's max-255 to leave room for editorial tweaks)
 *
 * Returns an empty string for inputs that yield no usable characters
 * (e.g. RTL-only text); callers should guard before writing the field
 * so they don't clear a user-typed slug.
 */
export function slugify(input: string): string {
  if (!input) return '';
  const out = input
    .normalize('NFKD')
    // Strip all combining marks (Unicode category M) so accents drop off:
    // "Yorùbá" → "yoruba", "Café" → "cafe".
    .replace(/\p{M}/gu, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return out.slice(0, 80);
}
